import React, { useState } from 'react';
import axios from 'axios';
import Alerts from '../components/Alerts';
import './VerifyPayment.css';
import { config, Contact, API_URL, PK_SECRET, UserCode } from '../components/Include';
import { useSelector } from 'react-redux';

const VerifyPayment = () => {
  const student = useSelector((state: any) => state.rootReducer.student);
  
  const [paymentInfo, setPaymentInfo] = useState({
    reference: '',
    payment_gateway: 'Paystack',
    matric_no: ''
  });
  const [errors, setErrors] = useState({
    reference: '',
    matric_no: '',
    payment_gateway: '',
    is_loading: false
  });
  const [verificationStatus, setVerificationStatus] = useState<'idle' | 'verifying' | 'found' | 'success' | 'failed'>('idle');
  const [paymentDetails, setPaymentDetails] = useState<any>(null);

  const initial = {
    status:'',
    date:'',
    amount:'',
    description:'',
    gatewaye:''
  }
  const [verificationResult, setVerificationResult] = useState<any>(initial);

  // Handle payment submission to backend
  const handleSubmitPayment = async (paymentData: any) => {
    setErrors({ ...errors, is_loading: true });
    
    const fd = new FormData();
    const today = new Date().toISOString().slice(0, 10);
    
    // Extract metadata from payment
    const customFields = paymentData.metadata?.custom_fields || [];
    const skillCodeField = customFields.find((f: any) => f.variable_name === 'skill_code');
    const courseCodeField = customFields.find((f: any) => f.variable_name === 'course_code');
    const studentCodeField = customFields.find((f: any) => f.variable_name === 'student_code');
    const matricNoField = customFields.find((f: any) => f.variable_name === 'matric_no');
    


    fd.append('student_code', studentCodeField?.value);
    fd.append('application_code', courseCodeField?.value || '');
    fd.append('skill_code', skillCodeField?.value || '');
    fd.append('amount_paid', String(paymentData.amount / 100));
    fd.append('platform', paymentInfo.payment_gateway);
    fd.append('payment_ref', paymentData.reference);
    fd.append('response', '');
    fd.append('teller_number', paymentData.reference);
    fd.append('date_paid', paymentData.date);
    fd.append('staff_create', matricNoField);
    
    
    try {
      const url = `${API_URL}/student/invoice/payment`;
      const response = await axios.post(url, fd, config);
      
      if (response.data.status === 200) {
        setVerificationStatus('success');
        Alerts('success', response.data.message || 'Payment recorded successfully!', 'Success');
        
        // Update verification result
        setVerificationResult({
          status: 'Successful',
          date: paymentData.paid_at || today,
          amount: paymentData.amount / 100,
          description: 'Training Manual Fees',
          fullname: student?.full_name || matricNoField?.value || 'N/A'
        });
        
        setTimeout(() => {
          window.location.href = '/app/skills';
        }, 3000);
      } else {
        setVerificationStatus('failed');
        Alerts('danger', response.data.message || 'Failed to record payment', 'Error');
      }
    } catch (error: any) {
      setVerificationStatus('failed');
      Alerts('danger', error.message || 'An error occurred while recording payment', 'Error');
    } finally {
      setErrors({ ...errors, is_loading: false });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPaymentInfo({
      ...paymentInfo,
      [name]: value
    });
    // Clear error when user types
    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validate inputs
    let formErrors = { ...errors };
    let formIsValid = true;
    
    if (!paymentInfo.reference || !paymentInfo.reference.trim()) {
      formErrors.reference = 'Payment reference is required';
      formIsValid = false;
    }
    
    if (!paymentInfo.payment_gateway) {
      formErrors.payment_gateway = 'Payment gateway is required';
      formIsValid = false;
    }
    
    if (!formIsValid) {
      setErrors(formErrors);
      return;
    }
    
    // Show loading state
    setVerificationStatus('verifying');
    setErrors({ ...errors, is_loading: true });
    setVerificationResult(null);
    setPaymentDetails(null);
    
    try {
    
    } catch (error: any) {
      setVerificationStatus('failed');
      Alerts('danger', error.message || 'An error occurred during verification', 'Error');
      setErrors({ ...errors, is_loading: false });
    }
  };

  return (
    <div className="verify-payment-container">
      {/* Page Header */}
      <div className="page-header payment-page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="page-header-content">
                <h1>Payment Verification</h1>
                <p className="lead">In case of payment delays, manually check your payment status using your payment reference number and matriculation number. This ensures your payment is processed correctly and helps resolve any issues promptly.</p>
              
              </div>
            </div>
            <div className="col-lg-4">
              <div className="page-header-image">
                 <div className="shape-1"></div>
                <div className="shape-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="row">
          <div className="col-lg-6 sidebar-column ">
            {/* verification sidebar */}
            <div className="verification-sidebar m-6 p-6 ">
              <div className="sidebar-content">
                <div className="verification-header mx-4">
                  <h2>Payment Status</h2>
                  <div className="verification-badge">
                    <i className="ri-shield-check-line"></i>
                  </div>
                </div>
                
                
                <div className="info-card mx-4">
                  <div className="info-card-header">
                    <i className="ri-information-line"></i>
                    <h4>What You'll Need</h4>
                  </div>
                  <ul className="info-list">
                    <li>
                      <i className="ri-check-line"></i>
                      <span>Your 13 digit payment reference number (This can be found in the transaction email sent to you by the payment gateway)</span>
                    </li>
                  

                    <li>
                      <i className="ri-check-line"></i>
                      <span>Your Payment Gateway</span>
                    </li>
                  </ul>
                </div>
                
                <div className="contact-card mx-4">
                  <div className="contact-card-header">
                    <i className="ri-customer-service-line"></i>
                    <h4>Need Assistance?</h4>
                  </div>
                  <div className="contact-options">
                    <div className="contact-option">
                      <i className="ri-mail-line"></i>
                      <a href={`mailto:${Contact.email}`}>{Contact.email}</a>
                    </div>
                    <div className="contact-option">
                      <i className="ri-phone-line"></i>
                      <span>{Contact.telephone}</span>
                    </div>
                    <div className="contact-option">
                      <i className="ri-map-pin-line"></i>
                      <span>{Contact.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6 form-column">
            <div className="verification-form-container">
              <h3>Verify Your Payment</h3>
              <p>Please enter your payment details below</p>
              
              {errors.is_loading && (
                <div className="loading-overlay">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p>Verifying payment...</p>
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className={`form-control ${errors.reference ? 'is-invalid' : ''}`}
                    id="reference"
                    name="reference"
                    placeholder="Payment Reference"
                    value={paymentInfo.reference.slice(0,13)}
                    onChange={handleChange}
                  />
                  <label htmlFor="reference">Payment Reference</label>
                  {errors.reference && <div className="invalid-feedback">{errors.reference}</div>}
                </div>
                
                


                <div className="form-floating mb-4">
  <select
    className="form-select"
    id="payment_gateway"
    name="payment_gateway"
    value={paymentInfo.payment_gateway}
    onChange={(e) => {
      setPaymentInfo({
        ...paymentInfo,
        payment_gateway: e.target.value
      });
    }}
  >
    <option value="Paystack">Paystack</option>
    <option value="Flutterwave">Flutterwave</option>
  </select>
  <label htmlFor="payment_gateway">Payment Gateway</label>
</div>


                <button type="submit" className="btn btn-primary btn-lg w-block" disabled={errors.is_loading}>
                  {errors.is_loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Verifying...
                    </>
                  ) : (
                    <>Verify Payment</>
                  )}
                </button>
              </form>
              
              {/* display only when verificationResult is not null and has valid data */}
                  
              {verificationResult !== null && verificationResult.status && verificationResult.amount && (
                <div className="verification-result mt-4">
                  <h4>Verification Result</h4>
                  <div className="card">
                    <div className="card-body">
                      <div className="result-item">
                        <span className="result-label">Status:</span>
                        <span className={`result-value status-successful`}>
                          {verificationResult.status || 'N/A'}
                        </span>
                      </div>
                      <div className="result-item">
                        <span className="result-label">Amount:</span>
                        <span className="result-value">
                          ₦{verificationResult.amount?.toLocaleString() || 'N/A'}
                        </span>
                      </div>
                      <div className="result-item">
                        <span className="result-label">Payment Date:</span>
                        <span className="result-value">
                          {verificationResult.date || 'N/A'}
                        </span>
                      </div>
                      <div className="result-item">
                        <span className="result-label">Payment For:</span>
                        <span className="result-value">
                          {verificationResult.description || 'N/A'}
                        </span>
                      </div>

                      <div className="result-item">
                        <span className="result-label">Name:</span>
                        <span className="result-value">
                          {verificationResult.fullname || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPayment;
